module.exports = __webpack_public_path__ + "static/img/LogoDefault.1b3939d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LogoDefault.jpg
// module id = GFvi
// module chunks = 3